import isWebview from "is-ua-webview";
import { atom, useAtom } from "jotai";
import { useEffect } from "react";

const isNativeAtom = atom(true);
const useIsNative = () => {
  const [isNative, setIsNative] = useAtom(isNativeAtom);
  useEffect(() => {
    const userAgent = navigator.userAgent;
    setIsNative(isWebview(userAgent));
  }, []);

  return isNative;
};

export default useIsNative;
